<template>
    <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="personalForm" :model="personalForm" :rules="rules"
                 label-width="120px">
            <el-form-item label="手机号：" prop="mobilePhone">
                <el-input v-model.number="personalForm.mobilePhone" placeholder="请输入手机号"
                          maxlength="11" disabled></el-input>
            </el-form-item>
            <el-form-item label="验证方式：" prop="authentication">
                <el-radio-group v-model="personalForm.authentication" @change="changeCation()">
                    <el-radio :label="0">短信验证</el-radio>
                    <el-radio :label="1">邮箱验证</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="personalForm.authentication == 0" label="手机验证码：" prop="verificationCode">
                <div class="flex_b_c">
                    <el-input v-model.number="personalForm.verificationCode" style="margin-right: 10px"
                              placeholder="请输入手机验证码"
                              maxlength="6"></el-input>
                    <el-button size="small" type="primary" @click="sendVerificationCode()">发送验证码</el-button>
                </div>
            </el-form-item>
            <el-form-item v-else label="邮箱" prop="verifyEmail"
                          :rules="[{required: true, message: '请输入邮箱地址', trigger: 'blur'},{validator:validator.isEmail, trigger:'blur'}]">
                <div class="flex_b_c">
                    <el-input v-model="personalForm.verifyEmail" placeholder="请输入邮箱地址 邮箱（xxxxxxx@xxx.xxx）"
                              maxlength="30" style="margin-right: 10px"
                              auto-complete="new-password"></el-input>
                    <el-button size="small" type="primary" @click="sendVerificationCode()">发送验证码</el-button>
                </div>
            </el-form-item>
            <el-form-item label="新密码：" prop="password"
                          :rules="[{ required: true, message: '请输入新密码', trigger: 'blur' },{validator:validator.isPwd, trigger:'blur'}]">
                <el-input show-password v-model="personalForm.password"
                          placeholder="请输入新密码（8-20位包含大小写字母，数字，特殊符号例如@）"
                          maxlength="20"
                          auto-complete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="confirmPassword">
                <el-input show-password v-model="personalForm.confirmPassword"
                          placeholder="请确认新密码（8-20位包含大小写字母，数字，特殊符号例如@）"
                          maxlength="20" auto-complete="new-password"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "setPassword",
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value !== this.personalForm.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            title: '修改密码',
            visible: false,
            personalForm: {
                id: '',
                mobilePhone: '',
                authentication: 0,
                verificationCode: '',
                verifyEmail: '',
                password: '',
                confirmPassword: '',
            },
            rules: {
                authentication: [
                    {required: true, message: '请选择验证方式', trigger: 'change'},
                ],
                verificationCode: [
                    {required: true, message: '请输入手机验证码', trigger: 'blur'},
                ],
                confirmPassword: [
                    {required: true, message: '请输入确认密码', trigger: 'blur'},
                    {validator: validatePass2, trigger: 'blur'},
                ]
            },
        }
    },

    methods: {
        init() {
            this.visible = true
            this.$nextTick(() => {
                let userInfo = this.$store.state.user.userInfo;
                this.personalForm.id = userInfo.id
                this.personalForm.mobilePhone = userInfo.mobilePhone
            })
        },

        //
        changeCation() {
            if (this.personalForm.authentication == 0) {
                this.personalForm.verifyEmail = ''
                this.$refs.personalForm.clearValidate([
                    'verificationCode',
                ]);
            } else {
                this.personalForm.verificationCode = ''
                this.$refs.personalForm.clearValidate([
                    'verifyEmail',
                ]);
            }
        },

        //发送验证码
        sendVerificationCode() {
            //手机
            if (this.personalForm.authentication == 0) {
                this.$axios(this.api.allCommon.verifySms, {telNumber: this.personalForm.mobilePhone}, 'get').then(data => {
                    if (data && data.status) {
                        this.$message.success('发送成功')
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                //邮箱
                this.$refs.personalForm.validateField('verifyEmail', (valid) => {
                    if (!valid) {
                        this.$axios(this.api.allCommon.sysuserSendEmail,{data: this.personalForm.verifyEmail}, 'get').then(data => {
                            if (data && data.status) {
                                this.$message.success('发送成功')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            }
        },

        doSubmit() {
            this.$refs.personalForm.validate((valid) => {
                if (valid) {
                    this.$axios(this.api.user.sysuserUpdateById, {
                        ...this.personalForm,
                        type: 1,
                    }, 'post').then(data => {
                        if (data && data.status) {
                            this.$alert('修改成功，请重新登录', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    sessionStorage.clear();
                                    this.$router.replace({name: 'login'});
                                }
                            });
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },
    },
}
</script>

<style scoped>

</style>